// /app/frontend/src/features/choral-intelligence/RecommendationReason.jsx
import React from "react";

export default function RecommendationReason({ reason }) {
  return (
    <div
      className={`ci-reason ci-reason--${reason.strength}`}
      data-testid={`ci-reason-${reason.type}`}
    >
      <div className="ci-reason__label">{reason.label}</div>
      <div className="ci-reason__text">{reason.text}</div>
    </div>
  );
}
